import { FancyRadio } from 'apps/builder/components/settings/modal'
import { SettingsFieldSelect } from 'apps/builder/components/settings/modal/shared'
import { useDispatch } from 'react-redux'
import { updateEntry } from 'apps/builder/store/actions/entries'
import { RequiredToggle } from 'apps/builder/components/settings/modal/shared'

export const DropdownField = ({
  guid,
  label,
  required,
  //default: defaultValue = 'GC_BLANK_DEFAULT',// TODO: not used currently?
  style = 1,
  type,
  keyField,
  //minimum = 2,// TODO: not used currently?
  maximum = 5,
  entry_values,
}) => {
  const dispatch = useDispatch()

  const boxDefaultEntries = () => {
    if (entry_values.length > 0) {
      return entry_values.slice(0, maximum)
    } else {
      return [...Array(maximum)].map((value, i) => {
        return {
          placeholder: 'Type your choices here and press Enter',
          position: i,
        }
      })
    }
  }

  const emptyEntry_valuesCheck = () => {
    return entry_values.every(({ text }) => !text)
  }

  return (
    <>
      <div className="settings--row">
        <SettingsFieldSelect
          guid={guid}
          label={label}
          keyField={keyField}
          type={type}
        />

        <div className="toggles-group">
          <div className="toggle-wrapper">
            <RequiredToggle guid={guid} active={required} />
          </div>
        </div>
      </div>

      <div className="settings--format--wrapper">
        <label className="settings--label">Style</label>
        <FancyRadio
          id={`${guid}-2`}
          label={'Dropdown'}
          selected={style}
          value={style == 34 ? 34 : 3}
          onChange={(checked, value) => {
            checked
              ? (() => {
                  dispatch(
                    updateEntry({
                      guid,
                      type,
                      style: value,
                      default: 'GC_BLANK_DEFAULT',
                      entry_values: emptyEntry_valuesCheck()
                        ? []
                        : entry_values,
                    })
                  )
                })()
              : ''
          }}
        />
        <FancyRadio
          id={`${guid}-1`}
          label={'Radio Buttons'}
          selected={style}
          value={1}
          disabled={keyField}
          tooltip={keyField && `This style isn’t available for key fields.`}
          onChange={(checked, value) => {
            checked
              ? (() => {
                  dispatch(
                    updateEntry({
                      guid,
                      type,
                      reference_data_id: null,
                      reference_data_column: null,
                      style: value,
                      default: 'GC_BLANK_DEFAULT',
                      entry_values: emptyEntry_valuesCheck()
                        ? []
                        : entry_values,
                    })
                  )
                })()
              : ''
          }}
        />
        <FancyRadio
          id={`${guid}-3`}
          label={'Boxes'}
          selected={style}
          disabled={keyField}
          tooltip={keyField && `This style isn’t available for key fields.`}
          value={5}
          onChange={(checked, value) => {
            checked
              ? (() => {
                  dispatch(
                    updateEntry({
                      guid,
                      type,
                      reference_data_id: null,
                      reference_data_column: null,
                      style: value,
                      default: null,
                      minimum: 2,
                      maximum: 5,
                      entry_values: boxDefaultEntries(),
                    })
                  )
                })()
              : ''
          }}
        />
      </div>
    </>
  )
}
